import { TileYearList } from "@/config/lidar.export.config";

const state = {
  exportTileYear: TileYearList?.[0] ?? "",
  isSolidSquareSymbolConfig: TileYearList.reduce((acc, val) => ({ ...acc, [val]: false }), {}),
};

const getters = {};

const actions = {};

const mutations = {
  setExportTileYear(state, year) {
    state.exportTileYear = year ?? "";
  },
  setIsSolidSquareSymbolConfig(state, config) {
    if (config != null) {
      state.isSolidSquareSymbolConfig = config;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
